import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface ITechnicalErrorRequest {
  method?: string;
  url?: string;
  params?: Record<string, string> | string | undefined;
  data?: string | object | null | undefined;
}

export interface ITechnicalErrorResponse {
  status?: number;
  statusText?: string;
  data?: string | object | null | undefined;
  meta?: object | null | undefined;
  message?: string;
}

export interface ITechnicalError {
  id: number;
  message: string;
  request: ITechnicalErrorRequest;
  response: ITechnicalErrorResponse;
  networkError?: boolean;
  suppressToast?: boolean;
}

export interface ITechnicalErrorState {
  errors: ITechnicalError[];
  isErrorModal: boolean;
}

const initialState: ITechnicalErrorState = {
  errors: [],
  isErrorModal: false
};

const technicalError = createSlice({
  name: 'technicalError',
  initialState,
  reducers: {
    resetTechnicalError: () => initialState,
    setTechnicalErrorModal: (state, action: PayloadAction<boolean>) => {
      state.isErrorModal = action.payload;
      if (!action.payload) {
        state.errors = [];
      }
    },
    addTechnicalError: (state, action: PayloadAction<ITechnicalError>) => {
      state.errors.push(action.payload);
      if (state.errors.length > 5) state.errors.shift();
    }
    // addTechnicalError: (state, action: PayloadAction<ITechnicalError>) => {
    //   const exists = state.errors.some(
    //     (err) =>
    //       err.id === action.payload.id ||
    //       (err.message === action.payload.message &&
    //         err.request.url === action.payload.request.url &&
    //         err.response.status === action.payload.response.status)
    //   );
    //   if (!exists) {
    //     state.errors.push(action.payload);
    //     if (state.errors.length > 5) state.errors.shift();
    //   }
    // }
  }
});

export const {
  resetTechnicalError,
  setTechnicalErrorModal,
  addTechnicalError
} = technicalError.actions;

export default technicalError.reducer;
